import React, { useEffect, useContext, useState } from "react";
import { PageSettings } from "../config/page-settings";
import { Link, useHistory } from 'react-router-dom';
const Failer = (props) => {
    const context = useContext(PageSettings);
    const [rolename, setroleName] = useState(
        localStorage.getItem("loginRoleName")
    );
    useEffect(() => {
        context.handleSetPageSidebar(false);
        context.handleSetPageHeader(false);
        context.handleSetPageContentFullWidth(true);
        return () => {
            context.handleSetPageSidebar(true);
            context.handleSetPageHeader(true);
            context.handleSetPageContentFullWidth(false);
        };
    }, []);


    return (
        <div className="login login-with-news-feed" >
            <div class="fade page-sidebar-fixed page-header-fixed" id="page-container">
                <div class="container ">
                    <div class="row justify-content-center">
                        <div class="col-xl-4  success">
                            <a class="logo-image" href="javascript:void(0);"><img src="../assets/img/logo/Logo_S.jpg" alt="alternative" width="50px" height="60px" /></a>
                            <div class="text-container mt-5">
                                <i class="fa fa-exclamation-circle" style={{ color: 'red' }}></i>
                                <h1 class="h1-large mt-4 text-warning">Payment Failed! </h1>
                                <h3 class="p-large pt-2"> Your Transaction Failed, Please Try again</h3>
                                <h5 class="p-large  pt-3">The STT team</h5>

                                {
                                    rolename === "Admin" ?
                                        <Link to="/home"> <a href="javascript:void(0);" className="btn btn-outline-primary mt-3">Go to Home</a></Link>
                                        : rolename === "SuperAdmin" ?
                                            <Link to="/superdashboard"><a href="javascript:void(0);" className="btn btn-outline-primary mt-3"> Go to Home</a></Link>
                                            : <></>
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
export default Failer;